/**
 * @desc 处理 a 标签在 iframe 里的跳转行为，新打开窗口。
 * @author Kody
 */
import React from 'react';

import { isInIframe } from '@umu/umu-dom';
import { openWindow } from '@umu/umu-util';

export type ITarget = '_blank' | '_self';

interface IProps {
    children: JSX.Element | string;
    href?: string;
    target?: ITarget;
    className?: string;
    onClick?(e: React.MouseEvent<Element, MouseEvent>): void;
}
import '../../styles/common.import/button.scss';
import './frameA.scss';
export const A = (props: IProps) => {
    const { children = '', onClick, href, target = '_self', className = '' } = props;
    const inIframe = isInIframe();
    const clickHandle = (e: React.MouseEvent<Element, MouseEvent>) => {
        if (onClick) {
            onClick(e);
        } else if (!href) {
            return;
        } else if (target === '_blank' || inIframe) {
            openWindow(href);
        } else {
            openWindow(href, '_self');
        }
    };
    const render = () => {
        return (
            <button className={`frame-a imitate-a ${className}`} onClick={(e) => clickHandle(e)}>
                {children}
            </button>
        );
    };
    return render();
};
